<template>
  <el-button @click="handleScan" :class="className" :type="type" :data-id="dataId">
    <div class="d-flex flex-row gap-2 justify-content-center align-items-center">
      <span class="material-icons"> qr_code </span>
      <p class="m-0">{{ $i18n.t(title) }}</p>
    </div>
  </el-button>
</template>

<script setup>
import notify from '../utils/mixin-notify'

export default {
  name: 'QRScannerButton',
  mixins: [notify],
  props: {
    title: {
      type: String,
      default: 'tap_for_scanning',
    },
    redirectTo: {
      type: String,
    },
    type: {
      type: String,
      default: 'secondary',
    },
    className: {
      type: String,
      default: 'QRScannerButton',
    },
    dataId: {
      type: String,
      default: 'qr-scanner-button',
    },
    identifier: {
      type: String,
      required: true,
    },
  },
  methods: {
    registerBarcodeHandler() {
      window['afterBarcodeScan_' + this.identifier] = ({ scannedValue, identifier }) => {
        if (!this.redirectTo) {
          this.showNotification({
            title: 'Error',
            text: 'no_redirect_url_given',
            type: 'error',
            duration: this.$CORE.notificationDuration,
          })
        } else {
          if (scannedValue && identifier === this.identifier) {
            const redirectTo = this.redirectTo.replace('SCAN_VALUE', scannedValue)
            this.$router.push(redirectTo)
          }
        }
      }
    },
    handleScan() {
      if (!window?.ReactNativeWebView) {
        this.showNotification({
          title: 'Error',
          text: 'no_react_native_webview_detected',
          type: 'error',
          duration: this.$CORE.notificationDuration,
        })
        return
      }
      const eventData = {
        eventName: 'REQUEST_BARCODE',
        data: {
          identifier: this.identifier,
        },
      }
      window.ReactNativeWebView.postMessage(JSON.stringify(eventData))
    },
  },
  created() {
    this.identifier = this.identifier.trim()
    this.registerBarcodeHandler()
  },
}
</script>

<style scoped lang="scss"></style>
